define('uikit/collections/table.cell',['require','exports','module','underscore','backbone','marionette','../channel','../helper/browser','../extra/key.codes','../elements/dropdown','./table.row','../mixins/component.mixin','../views/proxy.options.view','templates'],function(require, exports, module) {
  var _                = require('underscore');
  var Backbone         = require('backbone');
  var Mn               = require('marionette');
  var channel          = require('../channel');
  var browser          = require('../helper/browser');
  var CODES            = require('../extra/key.codes');
  var Dropdown         = require('../elements/dropdown');
  var TableRowView     = require('./table.row');
  var ComponentMixin   = require('../mixins/component.mixin');
  var ProxyOptionsView = require('../views/proxy.options.view');
  var Templates        = require('templates');

  var DATA_FIELD = 'data';
  var FORMATTER_FIELD = 'formatter';

  var TableCellView = Mn.ItemView.extend(ComponentMixin).extend({

    tagName: 'td',

    events: {
      'click' : function() { this.triggerMethod('press'); }
    },

    options: {
      text         : '',
      link         : null,
      linkTarget   : null,
      useInlineLink: false,
      linkAriaLabel: '',
      linkTabIndex : "-1",
      width        : null,
      maxWidth     : null,
      minWidth     : null,
      selectable   : false,
      nowrap       : false,
      align        : null,
      rowSpan      : null,
      colspan      : null,
      collapsing   : false,
      negative     : false,
      positive     : false,
      warning      : false,
      disabled     : false,
      hasChildView : false,
      // determines if the cell should
      // have padding
      fitted       : false
    },

    forceUpdate: {
      link: true,
      linkTarget: true,
      useInlineLink: true,
      linkAriaLabel: true,
      text: true
    },

    template: Templates.App['table.cell'],

    internalViewOptions: {
      columnChildView: function() {
        var column      = this.getOption('columnModel');
        var columnIndex = this.getOption('columnIndex');

        var defaulOptions = {
          rowView: this.getOption('rowView'),
          cellView: this,
          columnModel: column,
          columnData: column.get(DATA_FIELD),
          columnIndex: columnIndex,
          rowIndex: this.getOption('rowIndex'),
          model: this.model
        };

        if (!column.get(FORMATTER_FIELD) && TableCellView.rowDataIsCollection(this.model, column)) {
          _.extend(defaulOptions, {
            type: TableCellView.Table,
            attributes: { style: 'background: transparent !important;' },
            headless: true,
            focusable: false,
            columns: [{data: column.get('childData') }],
            borderless: true,
            basic: true,
            bindings: {
              collection: column.get(DATA_FIELD)
            }
          });
        }

        if (column.get('childBindings')) {
          defaulOptions.bindings = Mn._getValue(column.get('childBindings'), this, [this.model, column, columnIndex]);
        }

        if (column.get('childView')) {
          defaulOptions.type = column.get('childView');
        }

        return _.extend(
          defaulOptions,
          Mn._getValue(column.get('childViewOptions'), this, [this.model, column, columnIndex])
        );
      }
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      var columnModel = this.getOption('columnModel');
      var dataField = columnModel.get(DATA_FIELD);
      var rowSpan = this.getOption('rowSpan');

      if (dataField) {
        this.listenTo(this.model, 'change:' + dataField, function() {
          this.updateTextOption();
        })
      }
      this.updateTextOption();

      if (rowSpan) {
        this.updateElementAttributes( {rowSpan: rowSpan} );
      }
    },

    updateTextOption: function() {
      var columnModel = this.getOption('columnModel');
      var dataField = columnModel.get(DATA_FIELD);
      var columnHasDataField = dataField != null;
      var formatter = columnModel.get(FORMATTER_FIELD);
      var value = this.model.get(columnModel.get(DATA_FIELD));
      this.text = _.isFunction(formatter)
        ? formatter(columnHasDataField ? value : this.model, this.model, columnModel, this.getOption('columnIndex'))
        : value;
    },

    onInjectedColumnChildView: function(view) {
      var columnModel = this.getOption('columnModel');
      this
        .listenToOnce(view, 'before:render', function() {
          if (_.isFunction(columnModel.get('onBeforeAdd'))) {
            columnModel.get('onBeforeAdd').call(this, view, this.model, columnModel);
          }
        }, this)
        .listenToOnce(view, 'render', function() {
          if (_.isFunction(columnModel.get('onAdd'))) {
            columnModel.get('onAdd').call(this, view, this.model, columnModel);
          }
        })
    },

    updateAttributes: function() {
      if (this.getBoolOption('link')) {
        this.$el.css('position', 'relative');
      } else {
        this.$el.css('position', '');
      }

      if (this.getBoolOption('width')) {
        this.$el.css('width', this.getOption('width'));
      } else {
        this.$el.css('width', '');
      }

      if (this.getBoolOption('maxWidth')) {
        this.$el.css('max-width', this.getOption('maxWidth'));
      } else {
        this.$el.css('max-width', '');
      }

      if (this.getBoolOption('minWidth')) {
        this.$el.css('min-width', this.getOption('minWidth'));
      } else {
        this.$el.css('min-width', '');
      }

      if (this.getBoolOption('colspan')) {
        this.$el.attr('colspan', this.getOption('colspan'))
      } else {
        this.$el.removeAttr('colspan');
      }

      this
          .addClass('nowrap', this.getBoolOption('nowrap'))
          .addClass(this.getOption('align') + ' aligned', this.getBoolOption('align'))
          .addClass('negative', this.getBoolOption('negative'))
          .addClass('positive', this.getBoolOption('positive'))
          .addClass('warning', this.getBoolOption('warning'))
          .addClass('disabled', this.getBoolOption('disabled'))
          .addClass('fitted', this.getBoolOption('fitted'))
    }

  },
  {

    rowDataIsCollection: function(rowModel, columnModel) {
      return (rowModel.get(columnModel.get(DATA_FIELD)) instanceof Backbone.Collection);
    },

    hasChildView: function(columnModel, rowModel) {
      return !!columnModel.get('childView') ||
      (TableCellView.rowDataIsCollection(rowModel, columnModel) && !columnModel.get(FORMATTER_FIELD));
    }
  });

  module.exports = TableCellView;
});

